import * as Panels from '../../util/panels';
import React from 'react';
import {ConfusionMatrixConfig} from './common';
import * as Query from '../../util/queryts';
import {toRunsDataQuery} from '../../containers/RunsDataLoader';
export type {ConfusionMatrixConfig};

const PANEL_TYPE = 'Confusion Matrix';

function transformQuery(query: Query.Query, config: ConfusionMatrixConfig) {
  const result = toRunsDataQuery(query, undefined, {fullSummary: true});
  return result;
}

export const Spec: Panels.PanelSpec<typeof PANEL_TYPE, ConfusionMatrixConfig> =
  {
    type: PANEL_TYPE,
    Component: React.lazy(() => import('./Component')),
    transformQuery,
  };
